<script>
  import ExpandableIcon from "./ExpandableIcon.svelte";
  export let label;
  export let isOpen = false;

  const toggle = () => (isOpen = !isOpen);
</script>

<div
  class="w-full relative group border border-b-black"
  class:border-transparent={!isOpen}
  class:border-black={isOpen}
  class:border-t-transparent={isOpen}
  class:first:border-t-black={isOpen}
  class:last:border-b-transparent={!isOpen}
  class:last:border-b-black={isOpen}
>
  <button
    class="w-full bg-neutral-50 flex flex-row items-center p-24 gap-40 md:gap-72"
    on:click={toggle}
    aria-expanded={isOpen}
  >
    <p class="w-full text-black text-left font-bold leading-relaxed tracking-wide">
      {label}
    </p>
    <ExpandableIcon {isOpen} />
  </button>

  <div class="box-border accordion" class:border-t={isOpen}>
    {#if isOpen}
      <div class="text-base bg-indigo-50 font-normal p-24 leading-6 tracking-wide">
        <slot />
      </div>
    {/if}
  </div>
</div>
